import React, { useState } from "react";
import { Col, Container, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import styles from "./videotheque.module.scss";
import ReactPlayer from "react-player/lazy";
import { translate } from "react-switch-lang";
import hasRoles from "../../../security/hasRoles";
import keycloak from "../../../security/keycloak-config";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import AddVideo from "../../Support/add-video/addVideo";
import { SortDirection } from "../../../models/SortDirection";
import { SupportVideoDto } from "../../../models/supportVideoDto";
import { CountryDto } from "../../../models/countryDto";
import VideoCard from "./video-card/videoCard";
import ClickAwayListener from "react-click-away-listener";
import { StatisticMediaDto } from "../../../models/statisticMediaDto";
import { ACTION } from "../../../models/action";

const Videotheque: React.FC<{
  t: (key: string) => {};
  categoryId: number;
  setFilteredDocuments: (listVideo: SupportVideoDto) => void;
  handleGetListSupport: () => void;
  resetAllFieldSearch: () => void;
  setColumnName: (name: string) => void;
  filteredDocuments: SupportVideoDto[];
  isListDisplayMode: boolean;
  currentPage: number;
  elementPerPage: number;
  path: string;
  setSortOrder: (order: string) => void;
}> = props => {
  toast.configure();
  const httpClient = useHttpClient(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [openModalEditSupport, setOpenModalEditSupport] = useState<boolean>(false);
  const [editSupport, setEditSupport] = useState<SupportVideoDto>();
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortIcon, setSortIcon] = useState<string>("sort");
  const [sortDirection, setSortDirection] = useState(SortDirection.SORT);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [indexVideo, setIndexVideo] = useState<number>(0);
  const [openVideoViewer, setOpenVideoViewer] = useState<boolean>(false);
  const [supportVideo, setSupportVideo] = useState<SupportVideoDto>(new SupportVideoDto());

  const handleClickOpenModalEditSupport = (data: SupportVideoDto) => {
    setEditSupport(data);
    setOpenModalEditSupport(!openModalEditSupport);
  };

  const handleDeleteSUpportVideo = (supportId: number) => {
    SweetAlert.fire({
      title: props.t("message_confirmation_delete_video"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/support_video/" + supportId).then(response => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          handleGetListSupport();
          resetAllFieldSearch();
        });
      }
    });
  };

  const sortTrainingPathList = (sortColumnName: string, isStatisticColumn: boolean) => {
    let params = { categoryId: props.categoryId, sortDirection: "ASC", sortColumn: sortColumnName, page: 0, size: props.elementPerPage };
    setSortColumn(sortColumnName);
    props.setColumnName(sortColumnName);
    let asc = false;
    if (sortDirection === SortDirection.SORT || sortDirection === SortDirection.SORT_DESC || sortColumnName !== sortColumn) {
      asc = true;
      params.sortDirection = "ASC";
      setSortIcon("sort-asc");
    } else {
      params.sortDirection = "DESC";
      asc = false;
      setSortIcon("sort-desc");
    }
    if (isStatisticColumn) {
      asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      props.filteredDocuments.sort(compareStatisticView);

      if (asc) {
        props.filteredDocuments.reverse();
      }
    } else {
      props.setSortOrder(params.sortDirection);
      httpClient.current?.get("/support_video/search", { params: params }).then(res => {
        props.setFilteredDocuments(res.data.content.map(data => data.content));
        asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      });
    }
  };

  function getSortIconClassName(columnName: string) {
    if (sortColumn === columnName) {
      return "fa fa-" + sortIcon;
    } else {
      return "fa fa-sort";
    }
  }

  const handleGetListSupport = () => {
    props.handleGetListSupport();
  };

  const toggle = index => {
    setDropdownOpen(!dropdownOpen);
    setIndexVideo(index);
  };

  const resetAllFieldSearch = () => {
    props.resetAllFieldSearch();
  };

  const handleClickOpenVideoViewer = (data: SupportVideoDto) => {
    if (!openVideoViewer) {
      setSupportVideo(data);
      if (!hasRoleAdmin) {
        let statisticMediaDto = new StatisticMediaDto();
        statisticMediaDto.categoryId = data.categoryId;
        statisticMediaDto.typeCategory = "1";
        statisticMediaDto.mediaId = data.supportId;
        statisticMediaDto.action = ACTION.VIEW;
        httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
      }
      setOpenVideoViewer(!openVideoViewer);
    } else {
      setOpenVideoViewer(!openVideoViewer);
    }
  };

  const compareStatisticView = (a, b) => {
    if (a.numberView < b.numberView) {
      return -1;
    }
    if (a.numberView > b.numberView) {
      return 1;
    }
    return 0;
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12} xl={12}>
          <Row>
            {!props.filteredDocuments.length && (
              <div style={{ width: "100%" }} className="text-center">
                {props.t("message_no_video")}
              </div>
            )}
            {props.isListDisplayMode &&
              props.filteredDocuments.map((data: SupportVideoDto, index: number) => (
                <Col key={data.supportId} sm={12} md={6} xl={3}>
                  <VideoCard
                    data={data}
                    handleClickOpenModalEditSupport={handleClickOpenModalEditSupport}
                    handleDeleteSUpportVideo={handleDeleteSUpportVideo}
                    handleClickOpenVideoViewer={handleClickOpenVideoViewer}
                  ></VideoCard>
                </Col>
              ))}

            {!props.isListDisplayMode && props.filteredDocuments.length > 0 && (
              <Row className={styles["document-table-row"]}>
                <div className={styles["container-table"]}>
                  <Table className={styles["document-table"]}>
                    <thead>
                      <tr>
                        <th className={styles["document-table-icon"]} scope="col"></th>
                        <th className={styles["document-table-nom"]} scope="col">
                          <span onClick={() => sortTrainingPathList("title", false)} className={styles["pointer"]}>
                            <i className={getSortIconClassName("title")}></i> {props.t("table_header.title")}
                          </span>
                        </th>
                        <th className={styles["document-table-thematique"]} scope="col">
                          {props.t("table_header.thematic")}
                        </th>
                        <th className={styles["document-table-type"]} scope="col">
                          {props.t("table_header.video_type")}
                        </th>
                        <th className={styles["document-table-date"]} scope="col">
                          <span onClick={() => sortTrainingPathList("dateSupport", false)} className={styles["pointer"]}>
                            <i className={getSortIconClassName("dateSupport")}></i> {props.t("table_header.date")}
                          </span>
                        </th>
                        <th className={styles["document-table-pays"]} scope="col">
                          {props.t("table_header.country")}
                        </th>
                        <th className={styles["document-table-pays"]} scope="col">
                          <span onClick={() => sortTrainingPathList("language", false)} className={styles["pointer"]}>
                            <i className={getSortIconClassName("language")}></i> {props.t("table_header.language")}
                          </span>
                        </th>
                        {hasRoleAdmin && (
                          <th className={styles["document-table-pays"]} scope="col">
                            <span onClick={() => sortTrainingPathList("view", true)} className={styles["pointer"]}>
                              <i className={getSortIconClassName("view")}></i> <i className="fa fa-eye"></i>
                            </span>
                          </th>
                        )}
                        {hasRoleAdmin && (
                          <th className={styles["document-table-actions"] + " text-center"} scope="col">
                            {props.t("table_header.actions")}
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {props.filteredDocuments.map((data: SupportVideoDto, index: number) => (
                        <tr key={data.supportId}>
                          <td>
                            <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
                              <div className="product-img text-center">
                                <div className={styles["react-player-container"]}>
                                  <ReactPlayer
                                    url={data.link}
                                    width="110px"
                                    height="80px"
                                    onError={() => {
                                      toast.error(props.t("message_toastr_inaccessible_video"), {
                                        position: toast.POSITION.TOP_RIGHT,
                                        autoClose: 5000,
                                      });
                                    }}
                                    playing={data.urlSupport ? true : false}
                                    controls={true}
                                    light={data.urlSupport ? data.urlSupport + "/preview" : false}
                                  />
                                </div>
                                <div className={styles["product-hover"] + " product-hover"}>
                                  <ul>
                                    <li
                                      onClick={() => {
                                        handleClickOpenVideoViewer(data);
                                      }}
                                      style={{ width: "auto" }}
                                    >
                                      <i className="icon-eye">
                                        <span className="m-l-5">{hasRoleAdmin && data.numberView}</span>
                                      </i>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">{data.title}</td>
                          <td className="align-middle">
                            {data.listThematic.map(thematic => (
                              <span key={thematic.thematicId} className="p-l-5">
                                {thematic.titleFrancais}
                              </span>
                            ))}
                          </td>
                          <td className="align-middle">{data.videoType.titleFrancais}</td>
                          <td className="align-middle">{data.dateSupport}</td>
                          <td className="align-middle">
                            {data.listCountry.map((country: CountryDto) => (
                              <span key={country.countryId} className="p-l-5">
                                {country.titleFrancais}
                              </span>
                            ))}
                          </td>
                          <td className="align-middle">{data.language}</td>
                          {hasRoleAdmin && <td className="align-middle">{data.numberView}</td>}
                          {hasRoleAdmin && (
                            <td onClick={event => event.stopPropagation()} className={`${styles["document-table-actions-icons"]} align-middle text-center`}>
                              <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                                <div className={`${styles["translate_wrapper-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                                  <div onClick={event => event.stopPropagation()} className={styles["current_lang-view"]}>
                                    <div
                                      className={styles["lang-view"] + " " + styles["label-list-view"]}
                                      onClick={event => {
                                        event.stopPropagation();
                                        toggle(index);
                                      }}
                                    >
                                      <i className={"fa fa-ellipsis-v  " + styles["icon-point"]}></i>
                                    </div>
                                  </div>
                                  <div className={`${styles["more_lang-view"]} ${dropdownOpen && index === indexVideo ? styles["active"] : ""}`}>
                                    <div
                                      className={styles["lang-view"]}
                                      onClick={event => {
                                        event.stopPropagation();
                                        handleClickOpenModalEditSupport(data);
                                      }}
                                    >
                                      <i id="tableIconBtn" className={`${styles["document-actions__btn-update"]}  fa fa-edit m-t-5`}></i>
                                      <span className={styles["lang-txt-view"]}>{props.t("button_update")}</span>
                                    </div>
                                    <div
                                      className={styles["lang-view"]}
                                      onClick={event => {
                                        event.stopPropagation();
                                        handleDeleteSUpportVideo(data.supportId);
                                      }}
                                    >
                                      <i id="tableIconBtn" className={`${styles["document-actions__btn-delete"]} fa fa-trash-o `}></i>
                                      <span className={styles["lang-txt-view"]}>{props.t("button_delete")}</span>
                                    </div>
                                  </div>
                                </div>
                              </ClickAwayListener>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Row>
            )}
          </Row>
        </Col>
      </Row>
      <Modal isOpen={openModalEditSupport} size="lg">
        <ModalHeader toggle={() => setOpenModalEditSupport(!openModalEditSupport)}></ModalHeader>
        <ModalBody className={styles["modal-body"]}>
          <div>
            <h6 className={styles["title-model"] + " p-20"}>{props.t("title_update_video")}</h6>
          </div>
          <AddVideo getListSupport={handleGetListSupport} support={editSupport} resetAllFieldSearch={resetAllFieldSearch} closeToggle={handleClickOpenModalEditSupport} path={props.path}></AddVideo>
        </ModalBody>
      </Modal>

      <Modal isOpen={openVideoViewer} toggle={() => handleClickOpenVideoViewer(new SupportVideoDto())} size="xl">
        <ModalHeader toggle={() => setOpenVideoViewer(!openVideoViewer)}></ModalHeader>
        <ModalBody>
          <ReactPlayer
            url={supportVideo?.link}
            width="100%"
            height="82vh"
            onError={() => {
              toast.error(props.t("message_toastr_inaccessible_video"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
            }}
            playing={supportVideo?.urlSupport ? true : false}
            controls={true}
            light={supportVideo?.urlSupport ? supportVideo.urlSupport + "/preview" : false}
          />
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default translate(Videotheque);
